module.exports = __webpack_public_path__ + "static/media/beaumonde_bg.c5b20573.webp";